
import Card from 'vux/src/components/card/index.vue'


export default {
data() {
return {};
},
async beforeMount() {
},
props: ['goodInfo'],
mounted() {
},
components: {
Card
},
computed: {},
methods: {
goToDetails(id) {
if(this.goodInfo.stock > 0){
this.$router.push({name: 'detailMb', query: { id, cid: this.$route.query.cid } });
}
},
},
watch: {}
};



// WEBPACK FOOTER //
// ./src/components/card/CardMb.vue